import React from "react";
import Style from '../Styles/Common.module.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from "react-router-dom";
import { IoArrowForwardCircleOutline } from "react-icons/io5";

const InfrastructureComponent = ()=>{
    return(
        <div className={Style.infrastructursec+ " "+Style.clear + " " + Style.mayoInfa}>
            <Container>
                <Row>
                    <Col lg={12}>
                        <div className={Style.center}>
                            <h2 className={Style.abouttitle}>INFRASTRUCTURE</h2>
                        </div>
                    </Col>
                    <Col lg={4} className={Style.memberWidth}>
                        <div className={Style.infrastructurbox}>
                            <div className={Style.img}>
                                <img src={require('../../assest/images/infrastructur-img01.png')} alt=""/>
                            </div>
                            <h3>Academics</h3>
                            <ul>
                                <li>Mayo College is affiliated to the CBSE. Also, likely to introduce International Curricula in near future.</li>
                                <li>The school integrates technology into teaching - learning process.</li>
                                <li>Smart Classes</li>
                                <li>Excellent Results</li>
                            </ul>
                        </div>
                    </Col>
                    <Col lg={4} className={Style.memberWidth}>
                        <div className={Style.infrastructurbox}>
                            <div className={Style.img}>
                                <img src={require('../../assest/images/infrastructur-img02.png')}alt="" />
                            </div>
                            <h3>Sports</h3>
                            <ul>
                                <li>The students regularly represent School at the IPSC, the CBSE and at the National School Games.</li>
                                <li>Resident Coaches are available for more than 20 sports.</li>
                                <li>More than 500 students can play various sports simultaneously.</li>
                            </ul>
                        </div>
                    </Col>
                    <Col lg={4} className={Style.memberWidth}>
                        <div className={Style.infrastructurbox}>
                            <div className={Style.img}>
                                <img src={require('../../assest/images/infrastructur-img03.png')} alt="" />
                            </div>
                            <h3>Co-curricular</h3>
                            <ul>
                                <li>More than 18 distinctive co-curricular activities are pursued at Mayo College.</li>
                                <li>Co-curricula's are integrated into school life.</li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
         </div>
    )
}

export default InfrastructureComponent;